module.exports = __webpack_public_path__ + "static/img/P2.5cad824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/P2.jpg
// module id = EbjQ
// module chunks = 1